/** The mailbox OAuth client. The customer app, `apps/internal` and the server exchange codes for it in every environment. */
export const GOOGLE_WEB_CLIENT_ID = '49146863114-s204g3r0lrcutfgq0v7sl3fpqinenngq.apps.googleusercontent.com';

export const MICROSOFT_CLIENT_ID = 'e0e83faf-e5d0-4c7a-b52b-cc994a5cde26';

/** Browser key, restricted by HTTP referrer in Google Cloud. */
export const GOOGLE_MAPS_BROWSER_API_KEY = 'AIzaSyDQNGurwD7PP3yp0dP4WjbKGqz1Wj_SuBc';

export const DATADOG_RUM_APPLICATION_ID = '3c016cf1-990e-412d-ad18-5d2e5743002b';
export const DATADOG_RUM_CLIENT_TOKEN = 'pubf56b4e482793bf11841a73bb9759e90f';

export const AMPLITUDE_API_KEY = 'fcc385528fc5a5c2c3b9ad6469b710b7';
